import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {
  private requestCount = 0;
  private loadingSubject = new BehaviorSubject<boolean>(false);

  constructor() { }
  show() {
    if (this.requestCount === 0) {
      setTimeout(() => {
        this.requestCount++;
        this.loadingSubject.next(true);
      });
    } else {
      this.requestCount++;
      this.loadingSubject.next(true);
    }
  }

  hide() {
    this.requestCount--;
    if (this.requestCount <= 0) {
      this.loadingSubject.next(false);
    }
  }

  get isLoading() {
    return this.loadingSubject.asObservable();
  }
}